import { TRootState } from "@/store";
import { createSelector } from "reselect";

export const selectGeneralParam = (state: TRootState) => state.generalParam;

export const selectToggleBigger1= createSelector(
    [selectGeneralParam],
    (generalParam) => generalParam.toggleBigger1
  );

  export const selectToggleBigger2= createSelector(
    [selectGeneralParam],
    (generalParam) => generalParam.toggleBigger2
  );

